/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gold: NonNullable<unknown>, platinum: NonNullable<unknown> }} Partner_Faq_Discount_AInputs */



/**
* | output |
* | --- |
* | "Gold partners get {gold} and Platinum partners {platinum} off the list price of seats and the Compliance Copilot. Storage, page packs and AI usage are not di..." |
*
* @param {Partner_Faq_Discount_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_discount_a = /** @type {((inputs: Partner_Faq_Discount_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Discount_AInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gold-Partner erhalten ${i?.gold} und Platinum-Partner ${i?.platinum} Rabatt auf den Listenpreis von Plätzen und dem Compliance Copilot. Speicher, Seitenpakete und KI-Nutzung sind nicht rabattiert. Die Preise in Ihren Abrechnungen enthalten den Rabatt bereits — am Ende wird nichts erneut abgezogen.`)
	return /** @type {LocalizedString} */ (`Gold partners get ${i?.gold} and Platinum partners ${i?.platinum} off the list price of seats and the Compliance Copilot. Storage, page packs and AI usage are not discounted. The prices on your bills already include the discount — nothing is taken off again at the end.`)
});